export default __webpack_public_path__ + "static/media/tuah-iphone.ac53bb90.png";